module.exports = __webpack_public_path__ + "img/sld_scb_9_t1_green.f0714259.svg";